import {
    USER_INFO,
    TOKEN
} from "../action-types/auth";

  const initialState = {
    user_info: null,
    token: ''
  }

  export default (state = initialState, { type, payload }) => {
    switch (type) {
      case USER_INFO:
        return {
          ...state,
          user_info: JSON.stringify(payload)
        };
      case TOKEN:
        return {
          ...state,
          token: payload
        };
      default:
        return state;
    }
  };
  